import React from 'react';
import './App.css';
import Bookings from './Bookings';
import './Bookings.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Booking App</h1>
      </header>
      <main>
        <Bookings />
      </main>
    </div>
  );
}

export default App;
